import { call, put, takeEvery } from 'redux-saga/effects';
import {
  ActionGetAllCouponListSuccess,
  ActionCreateCouponSuccess,
  ActionUpdateCouponSuccess,
  ActionGetCouponByIDSuccess,
  ActionGetCoupenHistorySuccess,
} from '../Actions/CouponAction';
import { handleApiResponse } from '../../utils/functions';
import {
  CREATE_COUPON,
  DELETE_COUPON,
  GET_ALL_COUPON_LIST,
  GET_COUPON_BY_ID,
  GET_COUPON_HISTORY,
  UPDATE_COUPON,
} from '../storeTypes';

const File = 'CouponSaga';

import {
  GetAllCouponApi,
  CreateCouponApi,
  UpdateCouponApi,
  GetCouponByIdApi,
  DeleteCouponApi,
  GetCouponHistoryApi,
} from '../../utils/api';

function* GetAllCouponSaga(action) {
  try {
    const response = yield call(GetAllCouponApi, action.payload);
    if (response?.status === 200) {
      if (typeof action.callBack === 'function') {
        action.callBack(response?.data?.data);
      }
      yield put(ActionGetAllCouponListSuccess(response?.data?.data[0] || []));
    }
  } catch (error) {
    handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
  }
}

function* CreateCouponSaga(action) {
  try {
    const response = yield call(CreateCouponApi, action.payload);
    if (response) {
      action?.callBack(response?.data);
      yield put(ActionCreateCouponSuccess(response?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* UpdateCouponSaga(action) {
  try {
    const response = yield call(UpdateCouponApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response?.data);
      yield put(ActionUpdateCouponSuccess(response?.data));
    }
  } catch (error) {
    if (error?.response?.status === 400) {
      action?.callBack(error?.response?.data);
    }
  }
}

function* GetCouponByIDSaga(action) {
  try {
    const response = yield call(GetCouponByIdApi, action.payload);
    if (response?.status === 200) {
      yield put(ActionGetCouponByIDSuccess(response?.data?.data[0] || {}));
    }
  } catch (error) {
    handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
  }
}

function* GetCouponHistorySaga(action) {
  try {
    const response = yield call(GetCouponHistoryApi, action.payload);
    if (response?.status === 200 || response.success) {
      yield put(ActionGetCoupenHistorySuccess({
        data: response?.data.data[0].data || [],
        total: response?.data.data[0].total || 0,
      }));
    }
  } catch (error) {
    handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack);
  }
}

function* DeleteCouponSaga(action) {
  try {
    const response = yield call(DeleteCouponApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(200);
    }
  } catch (error) {
    console.log(File + '/DeleteCouponSaga Error:', error);
  }
}

export function* CouponSaga() {
  yield takeEvery(GET_ALL_COUPON_LIST, GetAllCouponSaga);
  yield takeEvery(CREATE_COUPON, CreateCouponSaga);
  yield takeEvery(UPDATE_COUPON, UpdateCouponSaga);
  yield takeEvery(GET_COUPON_BY_ID, GetCouponByIDSaga);
  yield takeEvery(GET_COUPON_HISTORY, GetCouponHistorySaga);
  yield takeEvery(DELETE_COUPON, DeleteCouponSaga);
}